var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToggle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.667 6.917a3.083 3.083 0 1 0 0 6.166 3.083 3.083 0 0 0 0-6.166"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.667 4a6 6 0 1 0 0 12h6.666a6 6 0 0 0 0-12zm-4 6a4 4 0 0 1 4-4h6.666a4 4 0 0 1 0 8H6.667a4 4 0 0 1-4-4",
  clipRule: "evenodd"
})));
SvgToggle.displayName = "SvgToggle";
export { SvgToggle as ReactComponent };
export default SvgToggle;